module.exports = __webpack_public_path__ + "img/sd-cards.1db4c9df.svg";